export const environment = {
  production: false,
  registerUrl: 'http://api.register.dev.broadfactor.com',
  operation_api: 'http://api.dev.operations.new.broadfactor.com/',
  API_url: 'http://api.dev.antecipagov.com.br/',
  aditive_api: 'http://api.dev.signer.broadfactor.com/api/',
  register_api: 'http://api.register.dev.broadfactor.com/',
  signer_url: 'http://cloud-hom.bry.com.br/scad/workflow/',
  financial_url: 'http://finance.dev.broadfactor.com/'
};
